import { render, staticRenderFns } from "./AulasAlunos.vue?vue&type=template&id=36b929f6"
import script from "./AulasAlunos.vue?vue&type=script&lang=js"
export * from "./AulasAlunos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports